import { type CoWorkerCalendar } from "@/features/calendar/team-calendar/types";
import { Text } from "@repo/skapa";
import { ListView, ListViewItem } from "@repo/skapa";
import { clockIcon, personIcon } from "@repo/skapa";
import { t } from "@repo/translation";
import { CoWorkerName, LocalizedDateTimeRange } from "@repo/ui";
import { SectionContainer } from "@repo/ui";
import { FlexDiv } from "@repo/ui";
import { ModalSheet } from "@repo/ui";

interface WorkingHoursModalProps {
  isOpen: boolean;
  closeModal: (e?: any) => void;
  coWorker: CoWorkerCalendar;
}

export const WorkingHoursModal = ({
  isOpen,
  closeModal,
  coWorker,
}: WorkingHoursModalProps) => {
  return (
    <ModalSheet
      id="working-hours"
      title="Availability"
      visible={isOpen}
      onClose={closeModal}
    >
      <SectionContainer>
        <FlexDiv alignItems="center" justifyContent="space-between">
          <Text textStyle="Heading.S">{t("label.assigned_shift")}</Text>
        </FlexDiv>
        <ListView id="work-time" showDivider={false}>
          <ListViewItem
            leadingIcon={clockIcon}
            title={t("label.date_and_time")}
            description={
              coWorker.workHours.isWorking ? (
                <LocalizedDateTimeRange
                  fromDate={coWorker.workHours.startTime}
                  toDate={coWorker.workHours.endTime}
                />
              ) : (
                t("label.not_available")
              )
            }
          />
          <ListViewItem
            leadingIcon={personIcon}
            title={t("label.assigned_coworker")}
            description={<CoWorkerName email={coWorker.emailId} />}
          />
        </ListView>
      </SectionContainer>
    </ModalSheet>
  );
};
